<p-card styleClass="!shadow-none !border !border-[#dde1e6] ">
  <div class="font-bold text-base xlplus:text-lg">XBRL Conversion Tool</div>
  <div class="mt-2 font-lato text-taxpod-gray text-sm xlplus:text-base">
    Upload your <span class="text-[#21272A] font-bold">Word (*.docx)</span> or
    <span class="text-[#21272A] font-bold">PDF (*.pdf) </span>files below, and
    let the tool convert them to XBRL format.
  </div>
  <div class="font-lato text-base mt-2">
    <form
      [formGroup]="fileUpload"
      (ngSubmit)="submitForm()"
      class="flex flex-col gap-4"
    >
      <!-- // audit year dropdown -->
      <!-- <div>
        <div class="flex flex-row gap-3 2xl:gap-[20px] items-center">
          <label class="w-[90px] font-bold font-lato text-sm xlplus:text-base"
            >Audit Year</label
          >
          <p-select
            formControlName="selectedAuditYear"
            [options]="auditYear"
            placeholder="Select year"
            class="!text-sm xlplus:!text-base !h-[36px] xlplus:!h-[42px]"
            [class.ng-dirty]="fileUpload.dirty || fileUpload.touched"
            [class.ng-invalid]="
              selectedAuditYear?.invalid &&
              (fileUpload.dirty || fileUpload.touched)
            "
          />
        </div>
        @if (selectedAuditYear?.invalid && (fileUpload.dirty ||
        fileUpload.touched)) {
        <div class="ml-[102px] 2xl:ml-[110px] mt-1 xlplus:mt-2">
          @if (selectedAuditYear?.hasError('required')) {
          <p
            class="font-lato text-xs xlplus:text-sm font-normal text-[#e73a3a]"
          >
            Audit Year is required
          </p>
          }
        </div>
        }
      </div> -->

      <div>
        <div class="w-[90px] h-[20px] xlplus:h-[20px] mt-4 mb-2.5">
          <label class="font-bold font-lato text-sm xlplus:text-base"
            >Convert File</label
          >
        </div>
        <div class="flex gap-3 2xl:gap-[20px] items-center">
          <div class="flex-grow">
            <input
              #fileInput
              type="file"
              multiple
              class="hidden"
              (change)="onFileSelected($event)"
              [accept]="acceptAttr()"
              title="file"
            />

            <div
              class="h-[309px] xlplus:h-[410px] border-dashed rounded-lg border-[#A4A7AE] border-2 flex flex-col gap-0 items-center font-lato font-normal text-xs xlplus:text-sm text-taxpod-gray mt-2 p-2"
              (dragover)="!isFileLimitReached() && onDragOver($event)"
              (dragleave)="!isFileLimitReached() && onDragLeave($event)"
              (drop)="!isFileLimitReached() && onDrop($event)"
              [class.border-taxpod-blue]="isDragging && !isFileLimitReached()"
              [class.bg-[#F0FBFF]]="isDragging && !isFileLimitReached()"
              [class.opacity-50]="isFileLimitReached()"
              [class.cursor-not-allowed]="isFileLimitReached()"
            >
              <div class="h-full flex flex-col justify-center items-center">
                <svg
                  class="w-[30px] h-[31px] xlplus:w-[32px] xlplus:h-[33px]"
                  viewBox="0 0 32 33"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clip-path="url(#clip0_2583_52102)">
                    <path
                      d="M21.3334 21.8333L16.0001 16.5L10.6667 21.8333"
                      stroke="#9AB0B9"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M16 16.5V28.5"
                      stroke="#9AB0B9"
                      stroke-width="3.2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M27.1866 25.02C28.4871 24.311 29.5144 23.1892 30.1064 21.8315C30.6985 20.4738 30.8216 18.9577 30.4562 17.5223C30.0909 16.0869 29.2579 14.814 28.0888 13.9046C26.9198 12.9952 25.4811 12.501 23.9999 12.5H22.3199C21.9164 10.939 21.1642 9.4898 20.1199 8.26134C19.0756 7.03289 17.7664 6.05715 16.2907 5.4075C14.8151 4.75784 13.2113 4.45116 11.6001 4.51053C9.98886 4.56989 8.41204 4.99375 6.98818 5.75024C5.56433 6.50673 4.3305 7.57616 3.37944 8.87813C2.42839 10.1801 1.78487 11.6807 1.49725 13.2672C1.20964 14.8537 1.28542 16.4847 1.7189 18.0377C2.15238 19.5907 2.93227 21.0252 3.99995 22.2334"
                      stroke="#9AB0B9"
                      stroke-width="3.2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M21.3334 21.8333L16.0001 16.5L10.6667 21.8333"
                      stroke="#9AB0B9"
                      stroke-width="3"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_2583_52102">
                      <rect
                        width="32"
                        height="32"
                        fill="white"
                        transform="translate(0 0.5)"
                      />
                    </clipPath>
                  </defs>
                </svg>

                <p class="text-center text-sm">
                  Drag and drop a file here or
                  <span
                    class="font-bold"
                    [class.text-[#0b8ebb]]="!isFileLimitReached()"
                    [class.cursor-pointer]="!isFileLimitReached()"
                    [class.text-gray-400]="isFileLimitReached()"
                    [class.cursor-not-allowed]="isFileLimitReached()"
                    (click)="triggerFileInput()"
                    >browse</span
                  >
                  to upload.
                </p>
                <!--
                  Developer Note: this helper text is deliberately unchanged.

                  When the backend tightened the financial-statement filename
                  rule (2026-08-14) it suggested the UI spell out the full
                  `<anything>_FS.pdf` / `<anything>_FS.docx` shape here rather
                  than the shorter "one ending in _FS" below. We did not adopt
                  it: user-facing copy is the P.O.'s call, and no clearance was
                  given for a copywriting change. A backend suggestion is not
                  sign-off.

                  The wording is therefore a product decision, not an oversight
                  or a missed to-do — do not "finish the job" by rewording it.
                  If the fuller phrasing is wanted, raise it with the P.O.
                  first; the rule it would describe is already enforced by
                  `findFsFile()` and the `noFSFile` validator error, so this is
                  purely a wording question with no behavioural change attached.

                  RENEWED 2026-08-14: the backend asked a second time, with a
                  stronger case. They have since shipped a session-wide check
                  (FS_COMPANY_NAME_NOT_FOUND) whose most common cause is a
                  document set that omits the Annual Return, and they suggest
                  this text should name both the filename shape AND the fact
                  that supporting documents may be needed. We still did not
                  change it: a second request from the same team is still not
                  P.O. sign-off. Any replacement wording must come
                  from the P.O. — do not re-invent it here.
                -->
                <p class="text-center text-xs">
                  Supported format:
                  <span class="text-taxpod-gray font-bold"
                    >{{ supportedFormatLabel() }}<br
                  /></span>
                  Max file size:
                  <span class="text-taxpod-gray font-bold"
                    >{{ maxFileSizeLabel() }}.</span
                  ><br />
                  At least
                  <span class="text-taxpod-gray font-bold">2 files,</span> with
                  one ending in
                  <span class="text-taxpod-gray font-bold">_FS</span>
                </p>
              </div>
            </div>
          </div>
        </div>

        @if (selectedFile?.value?.length ?? 0 > 0) {
        <div class="">
          @if (selectedFile?.value?.length === 1) {
          <div class="mt-1 xlplus:mt-2 flex items-center gap-2 justify-between">
            <div
              class="flex items-center justify-start gap-1 font-lato font-normal text-sm text-black"
            >
              <svg
                class="w-[11px] h-[13px]"
                viewBox="0 0 11 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M1.83333 0.777771C1.3471 0.777771 0.880788 0.970925 0.536971 1.31474C0.193154 1.65856 0 2.12487 0 2.6111V12.3889C0 12.8751 0.193154 13.3414 0.536971 13.6852C0.880787 14.0291 1.3471 14.2222 1.83333 14.2222H9.16667C9.6529 14.2222 10.1192 14.0291 10.463 13.6852C10.8068 13.3414 11 12.8751 11 12.3889V5.26455V5.26447C11 5.02024 10.9511 4.77847 10.8564 4.55337C10.7616 4.32831 10.6229 4.12445 10.4483 3.95374L10.4482 3.95364L7.73494 1.3003L7.73491 1.30027C7.39241 0.965374 6.93243 0.777831 6.45341 0.777771H6.45333H1.83333ZM1.40121 2.17898C1.51582 2.06438 1.67126 1.99999 1.83333 1.99999H6.11111V3.83333C6.11111 4.31956 6.30427 4.78587 6.64808 5.12969C6.9919 5.47351 7.45821 5.66666 7.94444 5.66666H9.77778V12.3889C9.77778 12.551 9.71339 12.7064 9.59879 12.821C9.48418 12.9356 9.32874 13 9.16667 13H1.83333C1.67126 13 1.51582 12.9356 1.40121 12.821C1.28661 12.7064 1.22222 12.551 1.22222 12.3889V2.6111C1.22222 2.44903 1.28661 2.29359 1.40121 2.17898ZM9.20194 4.44444L7.33333 2.61707V3.83333C7.33333 3.9954 7.39772 4.15084 7.51232 4.26545C7.62693 4.38005 7.78237 4.44444 7.94444 4.44444H9.20194ZM3.66667 7.49999C3.32916 7.49999 3.05556 7.7736 3.05556 8.1111C3.05556 8.44861 3.32916 8.72222 3.66667 8.72222H7.33333C7.67084 8.72222 7.94444 8.44861 7.94444 8.1111C7.94444 7.7736 7.67084 7.49999 7.33333 7.49999H3.66667ZM3.66667 9.94444C3.32916 9.94444 3.05556 10.218 3.05556 10.5555C3.05556 10.8931 3.32916 11.1667 3.66667 11.1667H5.5C5.83751 11.1667 6.11111 10.8931 6.11111 10.5555C6.11111 10.218 5.83751 9.94444 5.5 9.94444H3.66667Z"
                  fill="#00B0ED"
                />
              </svg>

              <p
                class="truncate cursor-pointer max-w-[200px] text-xs xlplus:text-sm"
                [pTooltip]="tooltipContent"
                tooltipPosition="top"
                tooltipStyleClass="top-tooltip"
              >
                {{ selectedFile?.value?.[0]?.name }}
              </p>
              <ng-template #tooltipContent>
                <div
                  class="text-taxpod-gray font-lato text-xs xlplus:text-sm font-normal w-full"
                >
                  <p
                    class="whitespace-nowrap text-sm xlplus:text-base text-black"
                  >
                    {{ selectedFile?.value?.[0]?.name }}
                  </p>
                </div>
              </ng-template>
              <p class="max-w-[100px]">
                ({{ (selectedFile?.value?.[0]?.size ?? 0) | fileSize }})
              </p>
            </div>
            <svg
              class="w-[12px] h-[13px] cursor-pointer"
              (click)="removeFile(0)"
              viewBox="0 0 12 13"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M7.09131 0.5C7.5251 0.500116 7.94079 0.672775 8.24756 0.979492C8.55444 1.28637 8.72705 1.70273 8.72705 2.13672V2.68164H10.9087C11.2099 2.68164 11.4546 2.92629 11.4546 3.22754C11.4544 3.52865 11.2098 3.77246 10.9087 3.77246H10.3638V10.8633C10.3638 11.2972 10.1911 11.7136 9.88428 12.0205C9.5774 12.3274 9.16104 12.5 8.72705 12.5H3.27295C2.83896 12.5 2.4226 12.3274 2.11572 12.0205C1.80888 11.7136 1.63623 11.2972 1.63623 10.8633V3.77246H1.09131C0.790164 3.77246 0.545575 3.52865 0.54541 3.22754C0.54541 2.92629 0.790062 2.68164 1.09131 2.68164H3.27295V2.13672C3.27295 1.70273 3.44556 1.28637 3.75244 0.979492C4.05922 0.672781 4.47489 0.500096 4.90869 0.5H7.09131ZM2.72705 10.8633C2.72705 11.0079 2.78494 11.1467 2.88721 11.249C2.9895 11.3513 3.12829 11.4092 3.27295 11.4092H8.72705C8.87171 11.4092 9.0105 11.3513 9.11279 11.249C9.21503 11.1467 9.27295 11.0079 9.27295 10.8633V3.77246H2.72705V10.8633ZM4.90869 5.40918C5.20978 5.40918 5.45434 5.65307 5.45459 5.9541V9.22754C5.45446 9.52867 5.20986 9.77246 4.90869 9.77246C4.6077 9.77226 4.3639 9.52855 4.36377 9.22754V5.9541C4.36402 5.65319 4.60777 5.40938 4.90869 5.40918ZM7.09131 5.40918C7.3922 5.40942 7.63598 5.65322 7.63623 5.9541V9.22754C7.6361 9.52852 7.39227 9.77222 7.09131 9.77246C6.79014 9.77246 6.54554 9.52867 6.54541 9.22754V5.9541C6.54566 5.65307 6.79022 5.40918 7.09131 5.40918ZM4.90869 1.59082C4.76416 1.59092 4.62516 1.64877 4.52295 1.75098C4.42088 1.85323 4.36377 1.99222 4.36377 2.13672V2.68164H7.63623V2.13672C7.63623 1.99224 7.5791 1.85323 7.47705 1.75098C7.37486 1.64879 7.23582 1.59094 7.09131 1.59082H4.90869Z"
                fill="#5F5B5B"
              />
            </svg>
          </div>
          } @else {
          <div class="flex items-center gap-2 justify-between w-full">
            <p
              class="mt-1 xlplus:mt-2 font-lato font-normal text-xs xlplus:text-sm text-taxpod-gray"
            >
              {{ selectedFile?.value?.length }} files uploaded
              successfully.<span
                class="text-taxpod-blue cursor-pointer"
                (click)="showDialog()"
              >
                View all.</span
              >
            </p>
            <p-dialog
              [(visible)]="isVisible"
              styleClass="!w-[450px]"
              [modal]="true"
              [baseZIndex]="2000"
              appendTo="body"
            >
              <ng-template #headless>
                <div class="p-4">
                  <p class="font-inter font-semibold text-xl xlplus:text-2xl">
                    Uploaded File
                  </p>
                  @for(file of selectedFile?.value ; track $index) {
                  <div class="flex items-center my-2 gap-2 justify-between">
                    <div
                      class="flex items-center justify-start gap-1 font-lato font-normal text-sm text-black"
                    >
                      <svg
                        class="w-[12px] h-[12px]"
                        (click)="removeFile($index)"
                        width="11"
                        height="15"
                        viewBox="0 0 11 15"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M1.83333 0.777771C1.3471 0.777771 0.880788 0.970925 0.536971 1.31474C0.193154 1.65856 0 2.12487 0 2.6111V12.3889C0 12.8751 0.193154 13.3414 0.536971 13.6852C0.880787 14.0291 1.3471 14.2222 1.83333 14.2222H9.16667C9.6529 14.2222 10.1192 14.0291 10.463 13.6852C10.8068 13.3414 11 12.8751 11 12.3889V5.26455V5.26447C11 5.02024 10.9511 4.77847 10.8564 4.55337C10.7616 4.32831 10.6229 4.12445 10.4483 3.95374L10.4482 3.95364L7.73494 1.3003L7.73491 1.30027C7.39241 0.965374 6.93243 0.777831 6.45341 0.777771H6.45333H1.83333ZM1.40121 2.17898C1.51582 2.06438 1.67126 1.99999 1.83333 1.99999H6.11111V3.83333C6.11111 4.31956 6.30427 4.78587 6.64808 5.12969C6.9919 5.47351 7.45821 5.66666 7.94444 5.66666H9.77778V12.3889C9.77778 12.551 9.71339 12.7064 9.59879 12.821C9.48418 12.9356 9.32874 13 9.16667 13H1.83333C1.67126 13 1.51582 12.9356 1.40121 12.821C1.28661 12.7064 1.22222 12.551 1.22222 12.3889V2.6111C1.22222 2.44903 1.28661 2.29359 1.40121 2.17898ZM9.20194 4.44444L7.33333 2.61707V3.83333C7.33333 3.9954 7.39772 4.15084 7.51232 4.26545C7.62693 4.38005 7.78237 4.44444 7.94444 4.44444H9.20194ZM3.66667 7.49999C3.32916 7.49999 3.05556 7.7736 3.05556 8.1111C3.05556 8.44861 3.32916 8.72222 3.66667 8.72222H7.33333C7.67084 8.72222 7.94444 8.44861 7.94444 8.1111C7.94444 7.7736 7.67084 7.49999 7.33333 7.49999H3.66667ZM3.66667 9.94444C3.32916 9.94444 3.05556 10.218 3.05556 10.5555C3.05556 10.8931 3.32916 11.1667 3.66667 11.1667H5.5C5.83751 11.1667 6.11111 10.8931 6.11111 10.5555C6.11111 10.218 5.83751 9.94444 5.5 9.94444H3.66667Z"
                          fill="#00B0ED"
                        />
                      </svg>

                      <p
                        class="truncate cursor-pointer max-w-[200px] text-xs xlplus:text-sm"
                        [pTooltip]="tooltipContent"
                        tooltipPosition="top"
                        tooltipStyleClass="top-tooltip"
                      >
                        {{ file.name }}
                      </p>
                      <ng-template #tooltipContent>
                        <div
                          class="text-taxpod-gray font-lato text-xs xlplus:text-sm font-normal w-full"
                        >
                          <p
                            class="whitespace-nowrap text-sm xlplus:text-base text-black"
                          >
                            {{ file.name }}
                          </p>
                        </div>
                      </ng-template>
                      <p class="max-w-[100px]">
                        ({{ file.size | fileSize }})
                      </p>
                    </div>
                    <svg
                      class="w-[12px] h-[12px] cursor-pointer"
                      (click)="removeFile($index)"
                      viewBox="0 0 12 13"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M7.09131 0.5C7.5251 0.500116 7.94079 0.672775 8.24756 0.979492C8.55444 1.28637 8.72705 1.70273 8.72705 2.13672V2.68164H10.9087C11.2099 2.68164 11.4546 2.92629 11.4546 3.22754C11.4544 3.52865 11.2098 3.77246 10.9087 3.77246H10.3638V10.8633C10.3638 11.2972 10.1911 11.7136 9.88428 12.0205C9.5774 12.3274 9.16104 12.5 8.72705 12.5H3.27295C2.83896 12.5 2.4226 12.3274 2.11572 12.0205C1.80888 11.7136 1.63623 11.2972 1.63623 10.8633V3.77246H1.09131C0.790164 3.77246 0.545575 3.52865 0.54541 3.22754C0.54541 2.92629 0.790062 2.68164 1.09131 2.68164H3.27295V2.13672C3.27295 1.70273 3.44556 1.28637 3.75244 0.979492C4.05922 0.672781 4.47489 0.500096 4.90869 0.5H7.09131ZM2.72705 10.8633C2.72705 11.0079 2.78494 11.1467 2.88721 11.249C2.9895 11.3513 3.12829 11.4092 3.27295 11.4092H8.72705C8.87171 11.4092 9.0105 11.3513 9.11279 11.249C9.21503 11.1467 9.27295 11.0079 9.27295 10.8633V3.77246H2.72705V10.8633ZM4.90869 5.40918C5.20978 5.40918 5.45434 5.65307 5.45459 5.9541V9.22754C5.45446 9.52867 5.20986 9.77246 4.90869 9.77246C4.6077 9.77226 4.3639 9.52855 4.36377 9.22754V5.9541C4.36402 5.65319 4.60777 5.40938 4.90869 5.40918ZM7.09131 5.40918C7.3922 5.40942 7.63598 5.65322 7.63623 5.9541V9.22754C7.6361 9.52852 7.39227 9.77222 7.09131 9.77246C6.79014 9.77246 6.54554 9.52867 6.54541 9.22754V5.9541C6.54566 5.65307 6.79022 5.40918 7.09131 5.40918ZM4.90869 1.59082C4.76416 1.59092 4.62516 1.64877 4.52295 1.75098C4.42088 1.85323 4.36377 1.99222 4.36377 2.13672V2.68164H7.63623V2.13672C7.63623 1.99224 7.5791 1.85323 7.47705 1.75098C7.37486 1.64879 7.23582 1.59094 7.09131 1.59082H4.90869Z"
                        fill="#5F5B5B"
                      />
                    </svg>
                  </div>
                  }
                  <div class="flex justify-end">
                    <p-button
                      label="Close"
                      variant="outlined"
                      styleClass="!border-taxpod-blue !text-taxpod-blue hover:!bg-[#E0F2FE]"
                      (onClick)="closeDialog()"
                    ></p-button>
                  </div>
                </div>
              </ng-template>
            </p-dialog>
            <svg
              class="w-[12px] h-[13px] cursor-pointer"
              (click)="removeFiles()"
              width="12"
              height="13"
              viewBox="0 0 12 13"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M7.09131 0.5C7.5251 0.500116 7.94079 0.672775 8.24756 0.979492C8.55444 1.28637 8.72705 1.70273 8.72705 2.13672V2.68164H10.9087C11.2099 2.68164 11.4546 2.92629 11.4546 3.22754C11.4544 3.52865 11.2098 3.77246 10.9087 3.77246H10.3638V10.8633C10.3638 11.2972 10.1911 11.7136 9.88428 12.0205C9.5774 12.3274 9.16104 12.5 8.72705 12.5H3.27295C2.83896 12.5 2.4226 12.3274 2.11572 12.0205C1.80888 11.7136 1.63623 11.2972 1.63623 10.8633V3.77246H1.09131C0.790164 3.77246 0.545575 3.52865 0.54541 3.22754C0.54541 2.92629 0.790062 2.68164 1.09131 2.68164H3.27295V2.13672C3.27295 1.70273 3.44556 1.28637 3.75244 0.979492C4.05922 0.672781 4.47489 0.500096 4.90869 0.5H7.09131ZM2.72705 10.8633C2.72705 11.0079 2.78494 11.1467 2.88721 11.249C2.9895 11.3513 3.12829 11.4092 3.27295 11.4092H8.72705C8.87171 11.4092 9.0105 11.3513 9.11279 11.249C9.21503 11.1467 9.27295 11.0079 9.27295 10.8633V3.77246H2.72705V10.8633ZM4.90869 5.40918C5.20978 5.40918 5.45434 5.65307 5.45459 5.9541V9.22754C5.45446 9.52867 5.20986 9.77246 4.90869 9.77246C4.6077 9.77226 4.3639 9.52855 4.36377 9.22754V5.9541C4.36402 5.65319 4.60777 5.40938 4.90869 5.40918ZM7.09131 5.40918C7.3922 5.40942 7.63598 5.65322 7.63623 5.9541V9.22754C7.6361 9.52852 7.39227 9.77222 7.09131 9.77246C6.79014 9.77246 6.54554 9.52867 6.54541 9.22754V5.9541C6.54566 5.65307 6.79022 5.40918 7.09131 5.40918ZM4.90869 1.59082C4.76416 1.59092 4.62516 1.64877 4.52295 1.75098C4.42088 1.85323 4.36377 1.99222 4.36377 2.13672V2.68164H7.63623V2.13672C7.63623 1.99224 7.5791 1.85323 7.47705 1.75098C7.37486 1.64879 7.23582 1.59094 7.09131 1.59082H4.90869Z"
                fill="#5F5B5B"
              />
            </svg>
          </div>
          }
        </div>
        } @if (!canDropFiles()) {
        <div class="mt-1 xlplus:mt-2">
          <p
            class="font-lato text-xs xlplus:text-sm font-normal text-[#e73a3a]"
          >
            The file exceeds the upload limit
          </p>
        </div>
        } @if (selectedFile?.invalid && (fileUpload.dirty ||
        fileUpload.touched)) {
        <div class="mt-1 xlplus:mt-2">
          @if (selectedFile?.hasError('minFiles')) {
          <p
            class="font-lato text-xs xlplus:text-sm font-normal text-[#e73a3a]"
          >
            At least 2 files are required
          </p>
          } @if (selectedFile?.hasError('maxFiles')) {
          <p
            class="font-lato text-xs xlplus:text-sm font-normal text-[#e73a3a]"
          >
            The file exceeds the upload limit
          </p>
          } @if (selectedFile?.hasError('invalidFormat')) {
          <p
            class="font-lato text-xs xlplus:text-sm font-normal text-[#e73a3a]"
          >
            Invalid file format. Supported format: {{ supportedFormatLabel() }}
          </p>
          } @if (selectedFile?.hasError('maxSize')) {
          <p
            class="font-lato text-xs xlplus:text-sm font-normal text-[#e73a3a]"
          >
            File size should be less than {{ maxFileSizeLabel() }}
            <!--
              Deliberately NOT echoing the offending size here. `formatFileSize`
              rounds to nearest, so a file between 50,000,001 and 50,049,999 bytes
              renders as "50 MB" — the same string as the cap — and the sentence
              would read "less than 50 MB (Your largest file is 50 MB)". See the
              KNOWN LIMITATION note in `utils/file-size.util.ts`.

              @if (selectedFile?.getError('maxSize')?.largestFileSize; as largest)
              { (Your largest file is {{ largest | fileSize }}) }
            -->
          </p>
          } @if (selectedFile?.hasError('noFSFile')) {
          <p
            class="font-lato text-xs xlplus:text-sm font-normal text-[#e73a3a]"
          >
            At least one file should end with _FS
          </p>
          }
        </div>
        } @if (isFileInvalid()) {
        <div class="mt-1 xlplus:mt-2">
          <p
            class="font-lato text-xs xlplus:text-sm font-normal text-[#e73a3a]"
          >
            Invalid file format. Supported format: {{ supportedFormatLabel() }}
          </p>
        </div>
        }
      </div>
      <div class="flex flex-wrap items-end gap-4">
        <p-button
          [disabled]="isButtonDisabled()"
          [loading]="isSubmitting()"
          type="submit"
          styleClass="!bg-taxpod-blue !border-taxpod-blue !font-lato !font-bold !text-base  disabled:!text-[#83858a] disabled:!bg-[#d5d7da] disabled:!border-[#d5d7da]"
          ><span class="font-bold font-lato text-sm xlplus:text-base"
            >Convert to XBRL</span
          ></p-button
        >

        <!--
          A brand-new conversion has no engine history, so lastUsedEngine is
          null and the picker resolves to the server's configured default. The
          control is never disabled here: a Phase 1 upload always starts a run.
        -->
        <app-conversion-engine-picker
          [disabled]="false"
          [lastUsedEngine]="null"
          (engineChange)="onEngineChange($event)"
        ></app-conversion-engine-picker>
      </div>
    </form>
  </div>
</p-card>
